// Marks that the user explicitly signed out, so ProtectedShell shows a
// "Signed out" landing instead of immediately re-triggering signinRedirect
// (which would silently re-auth via the still-active Workspace SSO session).
//
// Uses localStorage (not sessionStorage) so the flag survives the cross-origin
// redirect chain through Cognito + Workspace, which can otherwise drop the
// sessionStorage in some browsers. The flag is cleared whenever a successful
// auth lands (see ProtectedShell's `if (auth.isAuthenticated) clearSignedOut()`),
// so it never stays stale after a real re-login.
const KEY = "support_v2_signed_out";

export function markSignedOut() {
  localStorage.setItem(KEY, "1");
  // Belt and suspenders: nuke any oidc-client-ts state in BOTH storages so
  // the post-logout landing can't pick up a stale cached user. Keys used by
  // oidc-client-ts: `user:<authority>:<client_id>` for the user record, and
  // `oidc.<state-id>` for in-flight auth state nonces.
  for (const store of [localStorage, sessionStorage]) {
    for (let i = store.length - 1; i >= 0; i--) {
      const k = store.key(i);
      if (k && (k.startsWith("user:") || k.startsWith("oidc."))) {
        store.removeItem(k);
      }
    }
  }
}

export function clearSignedOut() {
  localStorage.removeItem(KEY);
}

export function isSignedOut(): boolean {
  return localStorage.getItem(KEY) === "1";
}
